export default __webpack_public_path__ + "static/media/Attribute_Finesse.e37ad35c.png";